import PostPageHandler from '@/PostPageHandler'

export default [
  {
    path: '/posts',
    component: PostPageHandler,
  },
]
